exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml,body { height:100%; }\n\nbody {\n\tposition: relative;\n\toverflow-x: hidden;\n\tfont-family: 'Montserrat';\n\tcolor: #0f1733;\n\tletter-spacing: 1.6px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/agencehoffman/Desktop/Workspace/catherinet/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/agencehoffman/Desktop/Workspace/catherinet/node_modules/postcss-loader?{"ident":"postcss"}!/Users/agencehoffman/Desktop/Workspace/catherinet/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles